/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { instanceOfComparisonRule, ComparisonRuleFromJSONTyped, ComparisonRuleToJSON } from './ComparisonRule';
import { instanceOfLogicRule, LogicRuleFromJSONTyped, LogicRuleToJSON } from './LogicRule';

/**
 * @type LogicRuleExpressionsInner
 *
 * @export
 */

export function LogicRuleExpressionsInnerFromJSON(json) {
  return LogicRuleExpressionsInnerFromJSONTyped(json, false);
}
export function LogicRuleExpressionsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  if (instanceOfComparisonRule(json)) {
    return ComparisonRuleFromJSONTyped(json, true);
  }
  if (instanceOfLogicRule(json)) {
    return LogicRuleFromJSONTyped(json, true);
  }
  return null;
}
export function LogicRuleExpressionsInnerToJSON(value) {
  if (value == null) {
    return value;
  }
  if (instanceOfComparisonRule(value)) {
    return ComparisonRuleToJSON(value);
  }
  if (instanceOfLogicRule(value)) {
    return LogicRuleToJSON(value);
  }
  return {};
}